import { render, staticRenderFns } from "./PopupBox.vue?vue&type=template&id=58c6129a&scoped=true&"
import script from "./PopupBox.vue?vue&type=script&lang=js&"
export * from "./PopupBox.vue?vue&type=script&lang=js&"
import style0 from "./PopupBox.vue?vue&type=style&index=0&id=58c6129a&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../var/task/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "58c6129a",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/var/task/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('58c6129a')) {
      api.createRecord('58c6129a', component.options)
    } else {
      api.reload('58c6129a', component.options)
    }
    module.hot.accept("./PopupBox.vue?vue&type=template&id=58c6129a&scoped=true&", function () {
      api.rerender('58c6129a', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "tmp/tmp-8kD9KJrWUUtqS/JS/comp/PopupBox.vue"
export default component.exports